<template>
    <div class="tabBar">
        <Tabbar v-model="activeItem"
                active-color="#2895ff"
                inactive-color="#c3c3c3"
                @change="onChange">
            <TabbarItem>
                <img slot="icon"
                     slot-scope="props"
                     :src="require(`../assets/images/ic_home${props.active ? '_click' : ''}.png`)" />
                <span>运营</span>
            </TabbarItem>
            <TabbarItem>
                <img slot="icon"
                     slot-scope="props"
                     :src="require(`../assets/images/ic_count${props.active ? '_click' : ''}.png`)" />
                <span>报表</span>
            </TabbarItem>
            <TabbarItem>
                <img slot="icon"
                     slot-scope="props"
                     :src="require(`../assets/images/ic_mine${props.active ? '_click' : ''}.png`)" />
                <span>我的</span>
            </TabbarItem>
        </Tabbar>
    </div>
</template>

<script>
    import {Tabbar, TabbarItem} from 'vant'
    export default {
        name: "tabBar",
        components: {
            Tabbar,
            TabbarItem
        },
        props: {
            activeIndex: {
                type: Number,
                default: 0
            }
        },
        watch: {
            activeIndex: {
                handler(val) {
                    this.activeItem = val;
                },
                immediate: true,
            }
        },
        data() {
            return {
                activeItem: 0
            }
        },
        methods: {
            onChange(index) {
                if (index === 0) {
                    this.toPage('/home', true)
                }
                if (index === 1) {
                    this.toPage('/reportForms', true)
                }
                if (index === 2) {
                    this.toPage('/mine', true)
                }
            }
        }
    }
</script>

<style lang='less' scoped>

</style>



// WEBPACK FOOTER //
// src/components/TabBar.vue